import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AuditActionType, AuditHelper } from './audit.helper';

@Injectable({ providedIn: 'root' })
export class LanesService {
  readonly section: string = 'Lanes';

  constructor(private _httpClient: HttpClient) {}

  getLotLanes(LotId): Observable<any> {
    return this._httpClient.get<any>('Lot/Lanes?LotId=' + LotId).pipe(map((response) => response.Data));
  }

  insertLane(lane: any): Observable<any> {
    return this.insertOrUpdate(lane, AuditActionType.CREATE);
  }

  updateLane(lane: any): Observable<any> {
    return this.insertOrUpdate(lane, AuditActionType.UPDATE);
  }

  delete(lane: any): Observable<any> {
    return this._httpClient.delete<any>('Lot/Lanes/' + lane.Id, {
      headers: AuditHelper.createAuditHeader({ entityId: lane.fkLot, section: this.section }),
    });
  }

  private insertOrUpdate(lane, method: AuditActionType): Observable<any> {
    const options = {
      body: { lane },
      headers: AuditHelper.createAuditHeader({
        entityId: lane.fkLot,
        section: this.section,
      }),
    };

    return this._httpClient.request(method, 'Lot/Lanes', options);
  }
}
